import { useState } from "react";

export default function StudentItem({
  studentName,
  studentId,
  setSelectedStudent,
  selectedStudent,
  purpose,
}) {
  const [checked, setChecked] = useState(false);

  function handleClick() {
    if (!checked) {
      setSelectedStudent([...selectedStudent, studentId]);
    } else {
      setSelectedStudent(selectedStudent.filter((id) => id !== studentId));
    }
    setChecked(!checked);
  }
  return (
    <div
      tabIndex={0}
      role="button"
      className={`border border-black px-2 py-1 mt-2 cursor-pointer m-1 select-none rounded sm:text-sm md:text-base ${
        checked
          ? purpose === "add"
            ? "bg-secondary-blue text-white hover:bg-tertiary-blue"
            : "bg-secondary-yellow text-white hover:bg-tertiary-yellow hover:text-black"
          : "bg-white hover:bg-gray-100"
      }`}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleClick();
        }
      }}
    >
      {studentName}
    </div>
  );
}
